<template>
  <div :key="src" style="display: inline-block">
    <img :src="compressImage" alt="" class="img" :style="{ width: width + 'px', height: height + 'px' }" @click="checkOriginalImage" />
    <el-image-viewer v-if="imgViewerVisible" :on-close="closeImgViewer" :url-list="[originalImage]" />
  </div>
</template>

<script>
import { getImgUrl, getCompressImage } from '@/api/getFile.js'
export default {
  name: 'ElImg',
  components: {
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer'),
  },
  props: {
    src: {
      type: String,
      default: '',
    },
    width: {
      type: [Number, String],
      default: 80,
    },
    height: {
      type: [Number, String],
      default: 80,
    },
    isRequest: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      imgViewerVisible: false,
    }
  },
  computed: {
    originalImage() {
      return this.isRequest ? getImgUrl(this.src) : this.src
    },
    compressImage() {
      return this.isRequest ? getCompressImage(this.src) : this.src
    },
  },
  methods: {
    checkOriginalImage() {
      this.imgViewerVisible = true
    },
    closeImgViewer() {
      this.imgViewerVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.img {
  display: inline-block;
  vertical-align: middle;
  margin: 0 5px;
}
</style>
